'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { faListUl } from '@fortawesome/pro-regular-svg-icons/faListUl';

import { Icon } from '@benzinga/core-ui';

export interface Items {
  id: string;
  text: string;
  url: string;
}

export interface TableOfContentsProps {
  items: Items[];
}

export const TableOfContents: React.FC<TableOfContentsProps> = ({ items: initialItems }) => {
  const [showAll, setShowAll] = React.useState<boolean>(false);

  const items = initialItems ?? [];
  const splicedItems = [...items].splice(0, 3);

  const handleShowAll = React.useCallback(() => {
    setShowAll(!showAll);
  }, [showAll]);

  const data = showAll ? items : splicedItems;

  if (!items?.length) {
    return <div />;
  }

  return (
    <Container className="bz3_border_box_container table">
      <div className="bz3_border_box_wrapper p-4 w-auto bg-white">
        <div className="bz3_table_content_title">
          <div className="font-semibold text-gray-900 text-left flex items-center justify-between">
            <div className="flex items-center justify-between gap-3">
              <Icon className="fa-list" icon={faListUl} />
              Table of Contents
            </div>
          </div>
        </div>
        <div className={`bz3_table_content_list`}>
          {data?.length && (
            <ul className="bz3_table_content_ul list-disc text-blue-200 ml-4 mt-2">
              {data.map((item: Items, i: number) => {
                const key = `bd-${i}`;
                const data = item;
                return data ? (
                  <li key={key}>
                    <a href={`#${item.id}`} title={item.text}>
                      {item.text}
                    </a>
                  </li>
                ) : (
                  ''
                );
              })}
              {!showAll && (
                <li className="see-all" onClick={handleShowAll}>
                  See All {items.length} Items
                </li>
              )}
            </ul>
          )}
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  margin-bottom: 1em;
  &.bz3_border_box_container {
    width: 100%;
    border: 1px solid #ceddf2;
    border-radius: 4px;
    .bz3_border_box_wrapper {
      padding: 0;
      width: 100%;
      .bz3_table_content_title {
        background: #e1ebfa;
        padding: 10px;
        cursor: pointer;
        font-size: 16px;
        h4 {
          font-family: sans-serif;
          margin: 0;
          span {
            font-weight: 100;
            a {
              font-weight: 700;
              color: #2ca2d1;
              &:hover {
                color: #07729c;
              }
            }
          }
        }
        .icon-wrap svg {
          color: #99aecc;
        }
      }
      .bz3_table_content_list {
        ul {
          list-style: none;
          margin: 0;
          li {
            padding: 6px 10px 6px 30px;
            border-bottom: 1px solid #ceddf2;
            position: relative;
            font-size: 14px;
            font-weight: 400;
            color: #2ca2d1;
            opacity: 1;
            transition: 0.6s;
            &:last-of-type {
              //border-bottom: 0;
            }
            &::before {
              content: '• ';
              font-size: 23px;
              line-height: 1;
              top: 50%;
              left: 1%;
              position: absolute;
              transform: translateY(-50%);
            }
            &.see-all {
              cursor: pointer;
              font-weight: 600;
              padding-left: 12px;
              &::before {
                display: none;
              }
            }
            a {
              &:hover {
                color: #07729c;
              }
            }
          }
        }
      }
    }
  }
`;
